export default __webpack_public_path__ + "static/media/NoProductImage.3ba9088c.jpg";